import RestClient from "@/api/utils/baseRestClient";
import atmoClient from "@/setup/clients/atmoClient";

class ProjectClientRest extends RestClient {
  async archiveOrUnarchiveProject(project) {
    const url = `${this.path}/${project.uuid}/archive_or_unarchive_project/`;
    const response = await this.client.put(url);
    return this.toCamel(response.data);
  }

  async update(form, uuid, config) {
    return this.partialUpdate(form, uuid, config);
  }

  async listFavorite() {
    const url = `${this.path}/list_favorites/`;
    const response = await this.client.get(url);
    return this.toCamel(response.data);
  }

  async toggleFavorite(uuid) {
    const url = `${this.path}/${uuid}/toggle_favorite/`;
    const response = await this.client.post(url);
    return this.toCamel(response.data);
  }

  async changeProjectManager(uuid) {
    const url = this.buildUrl(`${uuid}/change_project_manager/`);
    const response = await this.client.post(url);
    return this.toCamel(response.data);
  }
}

export const projectClientRest = new ProjectClientRest(atmoClient, "projects");
